import { pageHead } from "@app/framework/meta";
import { CompanyAnnouncementsPage } from "@modules/investor-relations/pages";
import { trans } from "@mongez/localization";
import { MetaFunction } from "@remix-run/node";
import { useLoaderData } from "@remix-run/react";

export default function CompanyAnnouncements() {
  useLoaderData();

  return <CompanyAnnouncementsPage />;
}

export const meta: MetaFunction = () => {
  return pageHead({
    title: trans("companyAnnouncements"),
    appendAppName: true,
  });
};
